import {Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {DbResponse} from "./db-response";
import {of} from 'rxjs';
import {catchError, filter, map} from "rxjs/operators";
import {Observable} from "rxjs/internal/Observable";

@Injectable()
export class DbResponseInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request, next: HttpHandler) {
    return next.handle(request)
      .pipe(
        filter((event) => event.type === HttpEventType.Response),
        map(event => {
          if (!this._isOutlineHandler(request)) {
            return DbResponse.create(event);
          }
          return event;
        }),
        catchError(errorResponse => {
          if (errorResponse instanceof HttpErrorResponse) {
            return of(DbResponse.create(errorResponse));
          } else {
            return of(DbResponse.create(errorResponse));
          }
        })) as Observable<HttpEvent<any>>;
  }

  private _isOutlineHandler(request: HttpRequest<any>): boolean {
    return request.url.includes('ai/outline_styles') ||
      request.url.includes('template_from_outline') ||
      request.url.includes('ai/outline') ||
      request.url.includes('/section_types') ||
      request.url.includes('ai/styles') ||
      request.url.includes('test/outline_styles') ||
      request.url.includes('sts-credentials/') ||
      request.url.includes('assets/json/textMap');  // Bypass translation files
  }

}
